<template>
  <div :id="sid+chartName" class="chart-wrapper" :style="esize"></div>
</template>
<script>
//import { CounterAmount } from "@/libs/lib.js";
//import {chartText} from "@/libs/mixins/chartSubText.js";
import { numFormat } from "@/mixins/NumFormat.js";
export default {
  name: "newCustomer",
  data() {
    return {
      chartName: this.$options.name,
      chartData: [{a:0,b:0}]
    };
  },
  props: {
    choosedOptions: {
      type: Object,
      default() {
        return {
          selectedList: [],
          keyword: ""
        };
      }
    },
    sid:{
      type:String,
      default:'a',
    },
    timeRange:{
      type:Number,
      default:1,
    },
    esize: {
      type: Object,
      default() {
        return { height: "15rem", width: "100%" };
      }
    },
    drawAgain: {
      type: Number,
      default: 1
    }
  },
  mixins: [numFormat],
  mounted() {},
  watch: {
    drawAgain: {
      immediate: true,
      handler(newVal) {
        if (newVal > 0) {
          this.get_data();
        }
      }
    }
  },
  computed: {
    ctdata() {
      return this.chartData;//Object.entries(CounterAmount(this.chartData, this.keyProp));
    },
    totalAmount(){
      let tmp = 0;
      for (let i of this.chartData){
        tmp += parseInt(i.value);
      }
      return tmp;
    },
    title(){
      if(this.timeRange===1){
        return "今日新老客户占比";
      }else{
        return "近"+this.timeRange+"日新老客户占比";
      }
    }
  },
  methods: {
    get_data() {
      let userToken = localStorage.getItem("current_user_token");
      this.$axios
        .post(this.$url + "/statistics", {
          askData: this.chartName,
          choosedOptions: this.choosedOptions,
          timeRange:this.timeRange,
          userToken: userToken
        })
        .then(response => ((this.chartData = response.data), this.drawIt()));
    },
    drawIt() {
      let vm = this;
      let myChart = this.$echarts.init(document.getElementById(vm.sid+vm.chartName));
      // 绘制图表
      myChart.setOption({
        backgroundColor: "#fff",
        title: {
          text: vm.title,
          subtext: '',//vm.selectedListTextFormat(vm.choosedOptions.selectedList),
          left: "center",
          top: "6%",
          textStyle: {
            fontSize:'0.6rem',
            fontWeight:800,
            color: "#888"
          }
        },
        tooltip : {
                trigger: 'item',
                formatter: "{d}%"
            },
        
        // legend: {
        //   width:'80%',
        //   bottom: 20
        // },
        dataset: {
          source: vm.ctdata
        },
        series: [
          {
            name: "数量",
            type: "pie",
            radius: 40,
            center: ["35%", "35%"],
            encode:{
              itemName:'name1',
              value:'value'
            },
            itemStyle: {
              opacity: 0.9
            }
          },
          {
            name: "金额",
            type: "pie",
            radius: 40,
            center: ["65%", "60%"],
            encode:{
              itemName:'name2',
              value:'price'
            },
            itemStyle: {
              opacity: 0.9
            }
          },
        ],
        // grid: {
        //   x: "20%",
        //   y: "20%",
        //   x2: "20%",
        //   y2: "20%",
        //   borderWidth: 10
        // },
        // label: {
          
        //   fontSize:'11',
        //   normal: {
        //     textStyle: {
        //       color: "rgba(255, 255, 255, 0.3)"
        //     }
        //   }
        // },
        // labelLine: {
        //   normal: {
        //     lineStyle: {
        //       color: "rgba(255, 255, 255, 0.3)"
        //     },
        //     smooth: 0.2,
        //     length: 10,
        //     length2: 20
        //   }
        // }
      });
      /**myChart.on('click', function (value) {
                    vm.$emit("clickToChange", { 'value': [value.name], 'key': vm.chartKey });

                });**/
      myChart.on("legendselectchanged", function(value) {
        vm.$emit("clickToAppend", {
          value: value.selected,
          key: vm.keyProp
        });
      });
    }
  }
};
</script>
<style scoped>
.chart-wrapper {
  border: 1px solid #f9f9f9;
  border-radius: 3px;
  margin: 0 auto;
}
.d-table{
  margin:0 auto;
  border:3px double #666;
  border-collapse: collapse;
  width:80%;
  text-align: center;
  font-size: 0.5rem;
}

.d-table td{
  border:1px solid #999;
}
</style>